<template>
    <div class="container">
        <transition name="fadeInGrow" appear>
            <div class="four-oh-four">
                <h1 class="title">404!</h1>
                <br/>
                <h2 class="subtitle is-1">
                    Hmmm... Couldn't find that one!
                </h2>
                <p>
                    Try going to the
                    <router-link :to="{name:'home'}">home page</router-link>
                    or use the navigation links above to find what you're looking for.
                </p>
            </div>
        </transition>
    </div>
</template>

<style lang="scss">
    .four-oh-four {
        text-align: center;
        padding-top: 10vh;
        padding-bottom: 10vh;
        .title {
            font-size: calc(12px + 10vh) !important;
            color: #c9302c;
        }
        .subtitle {
            font-size: calc(12px + 4vh) !important;
        }
    }
</style>

<script>
    export default {
        name: 'FourOhFour',
    }
</script>



// WEBPACK FOOTER //
// 404.vue?13405d58